import { useState, useEffect } from "react";
import axios from "axios";
import { Cake } from "lucide-react";
import { Badge } from "@/components/ui/badge";

import { API } from "../lib/api";
const ax = () => axios.create({ withCredentials: true });

export default function BirthdaysPage() {
  const [birthdays, setBirthdays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ax().get(`${API}/users/birthdays/upcoming`)
      .then(r => setBirthdays(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const today = birthdays.filter(b => b.days_until_birthday === 0);
  const upcoming = birthdays.filter(b => b.days_until_birthday > 0 && b.days_until_birthday <= 7);
  const later = birthdays.filter(b => b.days_until_birthday > 7);

  const BirthdayCard = ({ person }) => (
    <div className="bento-card p-4 flex items-center gap-4">
      <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0 ${person.days_until_birthday === 0 ? "" : ""}`}
        style={{ background: person.days_until_birthday === 0 ? "linear-gradient(135deg, #ffd724, #e6c220)" : "linear-gradient(135deg, #2346ff, #1d3ace)" }}>
        {person.picture ? (
          <img src={person.picture} alt={person.name} className="w-12 h-12 rounded-full object-cover" />
        ) : (
          <span style={{ color: person.days_until_birthday === 0 ? "#333" : "white" }}>{person.name.charAt(0)}</span>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-slate-900">{person.name}</p>
        <p className="text-sm text-slate-500">{person.department || "—"}</p>
        <div className="flex items-center gap-2 mt-1">
          <Cake className="w-3.5 h-3.5 text-slate-400" />
          <span className="text-sm text-slate-500">{person.birthday_formatted}</span>
        </div>
      </div>
      <div className="text-right flex-shrink-0">
        {person.days_until_birthday === 0 ? (
          <Badge className="bg-[#ffd724] text-slate-900 font-bold">Hoje!</Badge>
        ) : person.days_until_birthday <= 7 ? (
          <Badge style={{ backgroundColor: "#e8ecff", color: "#2346ff" }}>em {person.days_until_birthday}d</Badge>
        ) : (
          <span className="text-sm text-slate-400">{person.days_until_birthday} dias</span>
        )}
      </div>
    </div>
  );

  return (
    <div className="p-4 sm:p-6 max-w-3xl mx-auto">
      <div className="flex items-center gap-2 mb-6">
        <Cake className="w-5 h-5 text-pink-500" />
        <div>
          <h1 className="text-xl font-bold font-heading text-slate-900">Aniversariantes</h1>
          <p className="text-sm text-slate-500">Próximos 30 dias</p>
        </div>
      </div>

      {loading ? (
        <div className="space-y-3">{[...Array(5)].map((_, i) => <div key={i} className="h-20 bg-slate-100 rounded-xl animate-pulse" />)}</div>
      ) : birthdays.length === 0 ? (
        <div className="text-center py-16 text-slate-400">
          <Cake className="w-16 h-16 mx-auto mb-4 opacity-20" />
          <p className="text-base font-medium">Nenhum aniversariante nos próximos 30 dias</p>
          <p className="text-sm mt-1">Cadastre a data de nascimento dos colaboradores no painel admin</p>
        </div>
      ) : (
        <div className="space-y-6">
          {today.length > 0 && (
            <div>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 bg-[#ffd724] rounded-full" />
                <h2 className="text-sm font-semibold text-slate-700 uppercase tracking-wider">Hoje</h2>
              </div>
              <div className="space-y-2">
                {today.map(b => <BirthdayCard key={b.user_id} person={b} />)}
              </div>
            </div>
          )}
          {upcoming.length > 0 && (
            <div>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 bg-[#2346ff] rounded-full" />
                <h2 className="text-sm font-semibold text-slate-700 uppercase tracking-wider">Esta Semana</h2>
              </div>
              <div className="space-y-2">
                {upcoming.map(b => <BirthdayCard key={b.user_id} person={b} />)}
              </div>
            </div>
          )}
          {later.length > 0 && (
            <div>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-2 h-2 bg-slate-300 rounded-full" />
                <h2 className="text-sm font-semibold text-slate-400 uppercase tracking-wider">Próximos 30 Dias</h2>
              </div>
              <div className="space-y-2">
                {later.map(b => <BirthdayCard key={b.user_id} person={b} />)}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
